import deptorganize from '@/pcpage/system/organize/deptorganize'
import userinfo from '@/pcpage/system/organize/userinfo'
import demotionconfig from '@/pcpage/system/config/demotionconfig'
import layoutBlank from "@/layout/LayoutBlank"
import layout from '@/layout/Layout'

let router = [

    // 无菜单页面布局
    {
        path: '/layoutBlank',
        component: layoutBlank,
        children: [{
            path: 'deptorganize',
            component: deptorganize,
            meta: { title: 'MSSPTO' }
        },
        {
            path: 'userinfo',
            component: userinfo,
            meta: { title: 'MSSPTO' }
        },
        ]
    },
    {
        path: '/layout',
        redirect: "/layout/home",
        component: layout,
        children: [
          {
            path: 'demotionconfig',
            component: demotionconfig,
            meta: { title: 'MSSPTO' }
          },
         
        ]
      },
    {
        path: '*',
        component: () =>
            import ('@/pcpage/ptooa/error/404'),
        meta: { title: '页面走丢了' }
    },
    
]

export default router;


// WEBPACK FOOTER //
// ./src/router/sys_router.js